import React, {useEffect, useRef, useState} from 'react'
import ReactCrop, {centerCrop, makeAspectCrop,} from 'react-image-crop'
import {canvasPreview} from './canvasPreview'
import {useDebounceEffect} from '../helpers/useDebounceEffect'
import 'react-image-crop/dist/ReactCrop.css'
import compressImage from "../helpers/compressImage";
import {useMutation} from "react-query";
import {verifyImage} from "../Api";
import {RiLoaderFill} from "react-icons/ri";
import {BsFillPersonCheckFill} from "react-icons/bs";

// This is to demonstrate how to make and center a % aspect crop
// which is a bit trickier, so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
        makeAspectCrop({unit: '%', width: 90,},
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}

export default function ImageCropper({ghanaCard, setImageVerificationMessage}) {
    const [imgSrc, setImgSrc] = useState('')
    const previewCanvasRef = useRef(null)
    const imgRef = useRef(null)
    const inputImg = useRef(null)
    const [crop, setCrop] = useState()
    const [completedCrop, setCompletedCrop] = useState()
    const [scale, setScale] = useState(1)
    const [rotate, setRotate] = useState(0)
    const [aspect, setAspect] = useState(4 / 3)
    const [showImageCrop, setShowImageCrop] = useState(false)
    const {mutate: verifySelfie, isLoading, data, error} = useMutation(() => verifyImage({
        pinNumber: ghanaCard.toUpperCase(),
        image: imgSrc.replace('data:image/png;base64,', ''),
        dataType: "PNG",
        center: "BRANCHLESS",
        merchantKey: process.env.REACT_APP_MERCHANT_CODE
    }))
   

    //converts images to png
    function convertImage(file) {
        let src = URL.createObjectURL(file);

        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        let userImage = new Image();
        userImage.src = src;

        userImage.onload = function () {
            canvas.width = userImage.width
            canvas.height = userImage.height
            ctx.drawImage(userImage, 0, 0);

            const converted = canvas.toDataURL("image/png", 1)
            setImgSrc(converted)
        }
    }


    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
    }


    function dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        const byteString = atob(dataURI.split(',')[1]);

        // write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        const ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        return new Blob([ab], {type: 'image/png'});

    }

    async function onSelectFile(e) {
        setShowImageCrop(true)
        setImageVerificationMessage("")
        if (e.target.files && e.target.files.length > 0) {
            setCrop(undefined)
            const compress = await compressImage(e.target.files[0]);// Makes crop preview update between images.
            // convertImage(compress)
            const reader = new FileReader()
            reader.addEventListener('load', () => {
                    const blob = dataURItoBlob(reader.result)
                    convertImage(blob)
                }

                // setImgSrc(reader.result.toString() || ''),
            )
            reader.readAsDataURL(compress)
        }
    }

    function onImageLoad(e) {
        if (aspect) {
            const {width, height} = e.currentTarget
            setCrop(centerAspectCrop(width, height, aspect))
        }
    }

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                // We use canvasPreview as it's much faster than imgPreview.
                canvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                    scale,
                    rotate,
                )
            }
        },
        100,
        [completedCrop, scale, rotate],
    )

    useEffect(() => {
         //console.log('data',data)
        //279240
        if (data || error) {
            setImageVerificationMessage(data?.data || error?.response?.data)
            handleCancelVerification()
        }
    }, [data, error, setImageVerificationMessage])

    const handleVerifySelfie = () => {
        verifySelfie();
    }

    const handleCancelVerification = () => {
        setShowImageCrop(false)
        setImgSrc(null)
        // inputImg.current.value = null
    }

    return (
        <div className="max-w-lg w-full">
            {data?.data.code !== '00' && (
                <div className={`Crop-Controls ${data?.data.code !== '00' ? 'block' : 'hidden'} py-4 flex items-start`}>
                    <label
                        className="relative flex items-center justify-center space-x-2 p-2 rounded bg-blue-600 text-white w-full">
                        <BsFillPersonCheckFill/> <span>Take/Select selfie for verification</span>
                        <input type="file" accept="image/*" ref={inputImg} onChange={onSelectFile} 
                               className="opacity-0 absolute left-0"/>
                    </label>

                </div>)}

            {
                (showImageCrop) &&
                <div
                    className="fixed inset-0 flex items-center justify-center p-2 select-none max-w-[100vw] bg-black/30">
                    {Boolean(imgSrc) && (
                        <div className="px-4 py-6 bg-gray-50 rounded shadow-xl relative border">
                            <span className="py-2 block text-lg"> Crop Image for verification</span>
                            <ReactCrop
                                crop={crop}
                                onChange={(_, percentCrop) => setCrop(percentCrop)}
                                onComplete={(c) => setCompletedCrop(c)}
                                aspect={4 / 3}
                                minWidth={480}
                                minHeight={640}
                                maxHeight={640}
                                maxWidth={480}
                                locked={true}
                            >
                                <img
                                    ref={imgRef}
                                    alt="Crop me"
                                    src={imgSrc}
                                    style={{transform: `scale(${scale}) rotate(${rotate}deg)`,overflowY:'scroll',height:'80vh',width:'45vw'}}
                                    onLoad={onImageLoad}
                                />
                            </ReactCrop>
                            <div className="flex space-x-2 mt-4">
                                <button className="w-[50%] p-2 rounded text-slate-800 border"
                                        onClick={handleCancelVerification}> Cancel
                                </button>
                                <div className="w-[50%] p-2 rounded text-white bg-[#dd4f05]"
                                        onClick={handleVerifySelfie} disabled={isLoading}>
                                    Done
                                </div>
                            </div>

                            {isLoading &&
                                <div
                                    className="absolute inset-0 bg-black/10 flex flex-col space-y-2 items-center justify-center bg-black/30 z-20">
                                    <span className="text-white"> Verifying... </span>
                                    <RiLoaderFill className="animate-spin h-12 w-12 text-white"/>
                                </div>}
                        </div>
                    )}

                </div>
            }
        </div>
    )
}
